// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-k_gf","catalogByServiceItem__title":"c-k_gg"};